/**
 * Récupère l’identifiant du channel à utiliser en fonction de l’état de délégation.
 * @param {object} param0
 * @param {object} param0.configuration
 * @param {object} param0.room
 */
export default function bookingDelegationGetChannelId({
  configuration,
  room,
}: {
  room: ReturnType<
    typeof import("../../../normalizers/room/parseResource").default
  >;
  configuration: ReturnType<
    typeof import("../../../normalizers/configuration/parseData").default
  >;
}) {
  const { useBookingDelegation } = configuration.channel.website;
  if (useBookingDelegation) {
    return room?.mainChannel?.channelId;
  }
  return configuration.channel.id;
}
